import React from 'react'

function Users ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 18.5'>
      <path d='M89.582,9a4.25,4.25,0,1,1,4.25-4.25A4.254,4.254,0,0,1,89.582,9Zm0-7.5a3.25,3.25,0,1,0,3.25,3.25A3.252,3.252,0,0,0,89.582,1.5Zm0,0' transform='translate(-81.332)' />
      <path d='M323,6.5a3,3,0,1,1,3-3A3,3,0,0,1,323,6.5Zm0-5a2,2,0,1,0,2,2A2.006,2.006,0,0,0,323,1.5Zm0,0' transform='translate(-305)' />
      <path d='M16.5,212.168H0v-.75a8.25,8.25,0,0,1,16.5,0Zm-15.49,0H15.5c0-4.9-3.335-8-7.248-8a7.628,7.628,0,0,0-6.437,3.984A9.3,9.3,0,0,0,1.01,212.168Z' transform='translate(0 -193.168)' />
      <path d='M273.082,156.832h-.868c0-4-2.376-6-5.132-6a5.039,5.039,0,0,0-4.794,3.569l-.956-.287a6,6,0,0,1,11.75,1.719Zm0,0' transform='translate(-249.082 -142.332)' />
    </svg>
  )
}

Users.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Users
